export default function App(props) {
  return (
    <div className="Banner">
      <img className="Banner-Img desktop" src={props.img}></img>
    </div>
  );
}
